import request from '@/utils/request';

//查询mgm活动数据列表
export function getQueryActivityMgmList(values) {
  return request('/activityMgmReport/queryActivityMgmList', {
    method: 'POST',
    data: values,
  });
}
//导出活动数据
export function exportActivityDetail(values) {
  return request('/activityMgmReport/exportActivityDetail', {
    method: 'POST',
    data: values,
  });
}
